import {ArrayHelper} from "~/helpers/arrayHelper"
import {JoinType} from "~/models/conditionalRules/joinType"
import {IConditionalRuleSetRevive} from "~/interfaces/reviveInterfaces"
import Revive from "./revive"

export default class ConditionalRuleSetRevive extends Revive<IConditionalRuleSetRevive> implements IConditionalRuleSetRevive {
  client_id: string
  conditional_rules: IConditionalRuleSetRevive['conditional_rules']
  conditional_value: any
  conditional_value_formula: any
  default_value: any
  fieldName: string
  id: string
  join_type: JoinType
  sort_order: number

  get sortedConditionalRules(): IConditionalRuleSetRevive['sortedConditionalRules'] {
    return this.cached('sortedConditionalRules', () => {
      if (!this.conditional_rules) return []
      return ArrayHelper.sortByNumber(this.conditional_rules.slice(), 'sort_order')
    })
  }
}